import React, { useState, useEffect } from 'react';
import colors from '../../utils/colors';

const CoverIcon = () => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M2.74637 9.32174C4.07188 5.1113 8.13757 2.20121 12.7304 2.52449L12.7315 2.52456C15.9419 2.75388 18.6701 4.49941 20.2752 7.01189L20.4222 6.57388C20.598 6.05031 21.1649 5.76835 21.6885 5.94411C22.212 6.11986 22.494 6.68678 22.3182 7.21035L21.3682 10.0404C21.1925 10.5639 20.6256 10.8459 20.102 10.6701L17.272 9.72013C16.7484 9.54437 16.4665 8.97745 16.6422 8.45388C16.818 7.93031 17.3849 7.64835 17.9085 7.82411L18.5608 8.04308C17.2799 6.06757 15.1232 4.70065 12.5895 4.51951C8.94255 4.26307 5.70851 6.57291 4.65407 9.92231C4.48822 10.4491 3.92673 10.7417 3.39993 10.5759C2.87314 10.41 2.58053 9.84853 2.74637 9.32174Z"
      fill="#FAF7F5"
    />
    <path
      d="M14.1203 12.522C14.1203 13.726 13.1442 14.702 11.9403 14.702C10.7363 14.702 9.76025 13.726 9.76025 12.522C9.76025 11.3181 10.7363 10.342 11.9403 10.342C13.1442 10.342 14.1203 11.3181 14.1203 12.522Z"
      fill="#FAF7F5"
    />
    <path
      d="M20.4806 14.4782C21.0074 14.644 21.3 15.2055 21.1341 15.7323C19.8083 19.944 15.7317 22.8528 11.1401 22.5296L11.139 22.5295C7.92863 22.3002 5.20042 20.5547 3.59535 18.0422L3.44828 18.4803C3.27253 19.0039 2.70561 19.2858 2.18203 19.1101C1.65846 18.9343 1.3765 18.3674 1.55226 17.8438L2.50226 15.0138C2.67802 14.4902 3.24494 14.2083 3.76851 14.384L6.59851 15.334C7.12208 15.5098 7.40404 16.0767 7.22828 16.6003C7.05253 17.1239 6.48561 17.4058 5.96204 17.2301L5.30982 17.0111C6.5908 18.9866 8.74752 20.3535 11.2812 20.5345C14.9293 20.791 18.1724 18.4799 19.2264 15.1317C19.3923 14.6049 19.9538 14.3123 20.4806 14.4782Z"
      fill="#FAF7F5"
    />
  </svg>
);

const ExtendIcon = () => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M4 18.5C3.71667 18.5 3.47917 18.4042 3.2875 18.2125C3.09583 18.0208 3 17.7833 3 17.5V7.5C3 7.21667 3.09583 6.97917 3.2875 6.7875C3.47917 6.59583 3.71667 6.5 4 6.5C4.28333 6.5 4.52083 6.59583 4.7125 6.7875C4.90417 6.97917 5 7.21667 5 7.5V17.5C5 17.7833 4.90417 18.0208 4.7125 18.2125C4.52083 18.4042 4.28333 18.5 4 18.5Z"
      fill="#FAF7F5"
    />
    <path
      d="M18.175 11.5H9C8.71667 11.5 8.47917 11.5958 8.2875 11.7875C8.09583 11.9792 8 12.2167 8 12.5C8 12.7833 8.09583 13.0208 8.2875 13.2125C8.47917 13.4042 8.71667 13.5 9 13.5H18.175L15.3 16.4C15.1167 16.5833 15.0208 16.8125 15.0125 17.0875C15.0042 17.3625 15.1 17.6 15.3 17.8C15.4833 17.9833 15.7167 18.075 16 18.075C16.2833 18.075 16.5167 17.9833 16.7 17.8L21.3 13.2C21.4 13.1 21.4708 12.9917 21.5125 12.875C21.5542 12.7583 21.575 12.6333 21.575 12.5C21.575 12.3667 21.5542 12.2417 21.5125 12.125C21.4708 12.0083 21.4 11.9 21.3 11.8L16.7 7.20001C16.5167 7.01668 16.2875 6.92501 16.0125 6.92501C15.7375 6.92501 15.5 7.01668 15.3 7.20001C15.1 7.40001 15 7.63751 15 7.91251C15 8.18751 15.1 8.42501 15.3 8.62501L18.175 11.5Z"
      fill="#FAF7F5"
    />
  </svg>
);

const IntroIcon = () => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M5.825 13.5H15C15.2833 13.5 15.5208 13.4042 15.7125 13.2125C15.9042 13.0208 16 12.7833 16 12.5C16 12.2167 15.9042 11.9792 15.7125 11.7875C15.5208 11.5958 15.2833 11.5 15 11.5H5.825L8.7 8.59999C8.88333 8.41665 8.97917 8.18749 8.9875 7.91249C8.99583 7.63749 8.9 7.39999 8.7 7.19999C8.51667 7.01665 8.28333 6.92499 8 6.92499C7.71667 6.92499 7.48333 7.01665 7.3 7.19999L2.7 11.8C2.6 11.9 2.52917 12.0083 2.4875 12.125C2.44583 12.2417 2.425 12.3667 2.425 12.5C2.425 12.6333 2.44583 12.7583 2.4875 12.875C2.52917 12.9917 2.6 13.1 2.7 13.2L7.3 17.8C7.48333 17.9833 7.7125 18.075 7.9875 18.075C8.2625 18.075 8.5 17.9833 8.7 17.8C8.9 17.6 9 17.3625 9 17.0875C9 16.8125 8.9 16.575 8.7 16.375L5.825 13.5Z"
      fill="#FAF7F5"
    />
    <path
      d="M20 18.5C19.7167 18.5 19.4792 18.4042 19.2875 18.2125C19.0958 18.0208 19 17.7833 19 17.5V7.5C19 7.21667 19.0958 6.97917 19.2875 6.7875C19.4792 6.59583 19.7167 6.5 20 6.5C20.2833 6.5 20.5208 6.59583 20.7125 6.7875C20.9042 6.97917 21 7.21667 21 7.5V17.5C21 17.7833 20.9042 18.0208 20.7125 18.2125C20.5208 18.4042 20.2833 18.5 20 18.5Z"
      fill="#FAF7F5"
    />
  </svg>
);

const SpeedIcon = () => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M12 2.5C17.5143 2.5 22 6.98565 22 12.5C22 18.0143 17.5143 22.5 12 22.5C11.3557 22.5 10.8365 21.9808 10.8365 21.3365C10.8365 20.6922 11.3557 20.173 12 20.173C16.231 20.173 19.673 16.731 19.673 12.5C19.673 8.26899 16.231 4.82702 12 4.82702C7.76899 4.82702 4.32702 8.26899 4.32702 12.5C4.32702 13.1443 3.80781 13.6635 3.16351 13.6635C2.51921 13.6635 2 13.1443 2 12.5C2 6.98565 6.48565 2.5 12 2.5Z"
      fill="#FAF7F5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4485 7.88168C14.9039 7.51114 15.5786 7.53768 16.0026 7.96147C16.4263 8.3855 16.4529 9.06019 16.0824 9.5156L16.0026 9.60373L14.2294 11.3758C14.3242 11.6305 14.3829 11.9081 14.383 12.1999V12.2058C14.3829 13.5223 13.3164 14.5873 12 14.5877C10.6836 14.5874 9.61831 13.5223 9.6182 12.2058C9.6182 10.8893 10.6835 9.82433 12 9.82404C12.1576 9.8241 12.3064 9.84656 12.4454 9.87525L14.3604 7.96147L14.4485 7.88168ZM9.89925 12.6108C9.9007 12.6183 9.90248 12.6258 9.90401 12.6334C9.89018 12.5651 9.88022 12.4955 9.87305 12.425L9.89925 12.6108ZM14.1377 12.1999V12.2058C14.1377 12.3489 14.1239 12.4887 14.0972 12.6239C14.1101 12.5585 14.1213 12.4923 14.1281 12.425L14.1377 12.2058V12.1999ZM13.9436 11.3174C14.004 11.4514 14.053 11.5936 14.0865 11.7414L14.0257 11.5235C14.0019 11.453 13.9736 11.3842 13.9436 11.3174ZM10.9865 10.3218C10.8628 10.3884 10.7463 10.4665 10.6388 10.5553L10.8043 10.4326C10.8631 10.3929 10.9238 10.3557 10.9865 10.3218ZM12 10.067C12.1838 10.067 12.3571 10.0988 12.5252 10.1408L12.2691 10.0884C12.2258 10.0819 12.1814 10.0766 12.137 10.0729L12 10.067Z"
      fill="#FAF7F5"
    />
  </svg>
);

const ReplaceIcon = () => (
  <svg
    width={24}
    height={33}
    viewBox="0 0 24 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-8 relative"
    preserveAspectRatio="none"
  >
    <path
      d="M1.32627 26.98C0.68627 26.98 0.17627 26.2867 0.17627 25.4467V8.70002C0.17627 7.84669 0.68627 7.16669 1.32627 7.16669C1.96627 7.16669 2.47627 7.84669 2.47627 8.70002V25.4467C2.47627 26.2867 1.96627 26.98 1.32627 26.98Z"
      fill="#FAF7F5"
    />
    <path
      d="M19.2763 10.62C19.2763 9.87338 18.8263 9.27338 18.2663 9.27338H5.71627C5.15627 9.27338 4.70627 9.87338 4.70627 10.62V23.5267C4.70627 24.2734 5.15627 24.8734 5.71627 24.8734H18.2663C18.8263 24.8734 19.2763 24.2734 19.2763 23.5267V10.62Z"
      fill="#FAF7F5"
    />
    <path
      d="M21.5063 25.4467C21.5063 26.2867 22.0263 26.98 22.6563 26.98C23.2863 26.98 23.8063 26.2867 23.8063 25.4467V8.70002C23.8063 7.84669 23.2863 7.16669 22.6563 7.16669C22.0263 7.16669 21.5063 7.84669 21.5063 8.70002V25.4467Z"
      fill="#FAF7F5"
    />
  </svg>
);

const LibraryIcon = () => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M4 4.5C3.44772 4.5 3 4.94772 3 5.5V19.5C3 20.0523 3.44772 20.5 4 20.5C4.55228 20.5 5 20.0523 5 19.5V5.5C5 4.94772 4.55228 4.5 4 4.5Z"
      fill="#FAF7F5"
    />
    <path
      d="M8 4.5C7.44772 4.5 7 4.94772 7 5.5V19.5C7 20.0523 7.44772 20.5 8 20.5C8.55228 20.5 9 20.0523 9 19.5V5.5C9 4.94772 8.55228 4.5 8 4.5Z"
      fill="#FAF7F5"
    />
    <path
      d="M11 5.5C11 4.94772 11.4477 4.5 12 4.5C12.5523 4.5 13 4.94772 13 5.5V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V5.5Z"
      fill="#FAF7F5"
    />
    <path
      d="M15.2291 4.74388C14.7059 4.92074 14.4251 5.48825 14.602 6.01145L19.2969 19.9003C19.4738 20.4235 20.0413 20.7042 20.5645 20.5274C21.0877 20.3505 21.3685 19.783 21.1916 19.2598L16.4967 5.37098C16.3198 4.84778 15.7523 4.56702 15.2291 4.74388Z"
      fill="#FAF7F5"
    />
  </svg>
);

const UploadingModal = ({ 
  fileName = "Song title", 
  onCancel, 
  onContinue, 
  selectedOption = "Cover",
  onOptionSelect,
  isVisible = true,
  selectedMode = "Custom"
}) => {
  const [progress, setProgress] = useState(0);
  const [isCompleted, setIsCompleted] = useState(false);

  const allOptions = [
    {
      id: "Cover",
      label: "Cover",
      description: "Cover audio in any song style",
      icon: <CoverIcon />
    },
    {
      id: "Extend",
      label: "Extend", 
      description: "Make your audio longer",
      icon: <ExtendIcon />
    },
    {
      id: "Intro",
      label: "Intro",
      description: "Make your audio intro longer", 
      icon: <IntroIcon />
    },
    {
      id: "Speed",
      label: "Speed",
      description: "Slow down or speed up audio",
      icon: <SpeedIcon />
    },
    {
      id: "Replace",
      label: "Replace",
      description: "Replace audio section",
      icon: <ReplaceIcon />
    },
    {
      id: "Save to Library",
      label: "Save to Library",
      description: "Use this audio for later",
      icon: <LibraryIcon />
    }
  ];

  // Filter options based on selected mode (hide Intro and Replace in Simple mode)
  const options = selectedMode === "Simple" 
    ? allOptions.filter(option => !["Intro", "Replace"].includes(option.id))
    : allOptions;

  // Show upload progress and block Continue button
  useEffect(() => {
    if (!isVisible) return;

    // Reset progress when modal becomes visible
    setProgress(0);
    setIsCompleted(false);

    // Use CSS transition for smooth animation over 5 seconds
    const timer = setTimeout(() => {
      setProgress(100);
    }, 100); // Small delay to ensure initial state is rendered

    // Mark as completed after 5 seconds
    const completionTimer = setTimeout(() => {
      setIsCompleted(true);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(completionTimer);
    };
  }, [isVisible]);

  const handleCancel = () => {
    setProgress(0);
    setIsCompleted(false);
    onCancel?.();
  };

  const handleContinue = () => {
    onContinue?.(selectedOption);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="flex flex-col justify-start items-start w-[450px] overflow-hidden rounded-3xl bg-[#252020]">
        {/* Header with progress */}
        <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-4 p-6">
          <div className="flex justify-start items-center flex-shrink-0 gap-2">
            <div className="flex flex-col justify-center items-start flex-shrink-0 relative">
              <p className="text-sm font-medium text-left text-white truncate" style={{ maxWidth: '150px' }}>
                {fileName}
              </p>
              <p className="flex-grow-0 flex-shrink-0 text-sm text-left text-[#726e6c]">
                {isCompleted ? "Upload complete!" : "Uploading...."}
              </p>
            </div>
          </div>
          
          {/* Progress bar */}
          <div className="flex flex-col justify-start items-start flex-grow relative gap-2.5 rounded-[100px] bg-white/10">
            <div 
              className="flex-grow-0 flex-shrink-0 h-3 rounded-[100px]"
              style={{
                width: `${progress}%`,
                backgroundColor: isCompleted ? colors.states.success : colors.accent,
                transition: 'width 5s linear, background-color 0.3s ease'
              }}
            />
          </div>
          
          {/* Cancel button */}
          <div 
            className="flex justify-center items-center flex-grow-0 flex-shrink-0 h-10 relative gap-1 px-4 rounded-[100px] bg-[#363030] cursor-pointer hover:bg-opacity-80 transition-colors"
            onClick={handleCancel}
          >
            <p className="flex-grow w-[37px] text-xs font-medium text-left text-white">Cancel</p>
          </div>
        </div>
        
        {/* Options */}
        <div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-3 px-6">
          {options.map((option) => (
            <div
              key={option.id}
              className={`flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative overflow-hidden gap-4 p-4 rounded-xl cursor-pointer transition-colors ${
                selectedOption === option.id
                  ? 'bg-[#363030] border border-[#faf7f5]'
                  : 'bg-[#363030] hover:bg-opacity-80'
              }`}
              onClick={() => onOptionSelect?.(option.id)}
            >
              {option.icon}
              <div className="flex flex-col justify-start items-start flex-grow relative gap-0.5">
                <p className="self-stretch flex-grow-0 flex-shrink-0 w-[330px] text-sm font-medium text-left text-[#faf7f5]">
                  {option.label}
                </p>
                <p className="self-stretch flex-grow-0 flex-shrink-0 w-[330px] text-xs text-left text-[#bab4b1]">
                  {option.description}
                </p>
              </div>
            </div>
          ))}
        </div>
        
        {/* Continue button */}
        <div className="flex justify-start items-center self-stretch flex-grow-0 flex-shrink-0 gap-[9px] p-6">
          <div 
            className={`flex justify-center items-center flex-grow h-14 relative gap-1 px-[150px] py-[19px] rounded-[100px] transition-all ${
              isCompleted 
                ? 'bg-[#faf7f5] cursor-pointer hover:bg-opacity-90' 
                : 'bg-[#faf7f5]/50 cursor-not-allowed'
            }`}
            onClick={isCompleted ? handleContinue : undefined}
          >
            <p className={`flex-grow-0 flex-shrink-0 text-lg font-semibold text-left ${
              isCompleted ? 'text-[#0e0808]' : 'text-[#0e0808]/50'
            }`}>
              Continue
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadingModal;